export const JOIN_TIMER_MINUTES = 60;
export const JOIN_TIMER_SECONDS = JOIN_TIMER_MINUTES * 60;
